module.exports = __webpack_public_path__ + "static/media/1.dd1c884f.jpg";